
import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';

@Component
export default class DatePicker extends Vue {
  @PropSync('dateValue', { required: true }) syncedDateValue!: string | string[];

  @Prop({ default: false }) range!: boolean;

  @Prop({ default: true }) isFuture!: boolean;

  @Prop({ default() { return () => true; } }) allowedDates!:
  (date: string, currentValue?: string | string[]) => boolean;

  mounted() {
    this.$nextTick(() => {
      this.adjustPosition();
    });
  }

  private adjustPosition() {
    const element = this.$el as HTMLElement;
    if (!element) return;

    // On mobile, use fixed positioning centered on viewport
    if (window.innerWidth <= 768) {
      const parent = element.parentElement;
      if (parent) {
        const parentRect = parent.getBoundingClientRect();
        const pickerHeight = element.offsetHeight || 350;
        const spaceBelow = window.innerHeight - parentRect.bottom;

        if (spaceBelow >= pickerHeight + 5) {
          // Place below the input
          element.style.top = `${parentRect.bottom + 5}px`;
          element.style.bottom = 'auto';
        } else {
          // Place above the input
          element.style.bottom = `${window.innerHeight - parentRect.top + 5}px`;
          element.style.top = 'auto';
        }
      }
      return;
    }

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    if (rect.right > viewportWidth) {
      element.style.right = '0';
      element.style.left = 'auto';
    }

    if (rect.left < 0) {
      element.style.left = '0';
      element.style.right = 'auto';
    }

    if (rect.bottom > viewportHeight) {
      element.style.bottom = '100%';
      element.style.top = 'auto';
      element.style.marginTop = '0';
      element.style.marginBottom = '5px';
    }
  }

  private applyFilter() {
    this.$emit('applyFilter');
    this.closePicker();
  }

  private closePicker() {
    this.$emit('closePicker');
  }
}
